import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const updateUserDirectPhoto = async (directPhotoFormData) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.post(
			`${CONFIG.STUDENTURL}/api/v2/student/profile/photo`,
			directPhotoFormData,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		console.log(error);
		return [];
	}
};
